<template>
  <div class="wrapping">
    <b-row class="mt-4 main-content">
      <b-col sm="12" md="10" lg="10" offset-lg="1" offset-md="1">
        <h2 class="app_title">
          <span
            ><img :src="require(`../../assets/iridi_nest_logo.png`)" alt=""
          /></span>
          <span>iRidi for Nest</span>
        </h2>

        <p>
          A set of tools to create interfaces for controlling equipment by Nest.
          <br />
          <span class="glyphicon glyphicon-info-sign"></span> The driver is only
          for a server project.
        </p>

        <hr>
        <p>
          Please read our <router-link
            to="/policy/nest/privacy-policy-for-access-to-google-apis/en"
            >Privacy Policy for Accessing Google APIs</router-link
          > before using iRidi for Nest.
        </p>
        <hr>
        <br>
        <h2><span class="mw-headline" id="Description"></span>Description</h2>
        <p>
          iRidi for Nest is a set of tools that allows to create an interface
          to control Nest equipment. <br> A cloud driver interacts with equipment by
          means of HTTP requests.
        </p>
        <p><br /></p>
        <h2><span class="mw-headline" id="Connection"></span>Connection</h2>
        <p>To connect to Nest equipment, do the following:</p>
        <p>
          <span class="label label-default"> 1</span> Set a Google account to
          work with Nest equipment.
        </p>
        <p>
          <span class="label label-default"> 2</span> Create a cloud object for
          your iRidi pro project.
        </p>
        <p>
          <span class="label label-default"> 3</span> Follow the
          <a
            class="external text"
            href="https://cws.iridi.com/services/oauth/available"
            >link</a
          >
          log in with your iRidi dealer account.
        </p>
        <p>
          <span class="label label-default"> 4</span> Choose
          <b>Connect</b> (Set) for the Nest driver.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="IR assistant nest connect.png"
                src="https://dev.iridi.com/images/e/ea/IR_assistant_nest_connect.png"
              />
            </div>
          </div>
        </div>
        <p>
          <span class="label label-default"> 5</span> Accept a permission to
          view and use data about your home from the Google Home app.
        </p>
        <p>
          <span class="label label-default"> 6</span> Choose a required object
          in iRidi cloud.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="IR assistant choose object.png"
                src="https://dev.iridi.com/images/7/7f/IR_assistant_choose_object.png"
              />
            </div>
          </div>
        </div>
        <p>
          <span class="label label-default"> 7</span> Click <b>Link</b>. A
          session for linking can expire and in this case you'll see an error -
          <b>invalid_grant / Bad Request</b>. Go to point 4 and repeat the
          following steps.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="IR assistant nest connect 2.png"
                src="https://dev.iridi.com/images/d/db/IR_assistant_nest_connect_2.png"
              />
            </div>
          </div>
        </div>
        <p>
          <span class="label label-default"> 8</span> Download a JS file with a
          driver structure. You can see an a token to connect ot equipment below
          - OAuth3.0. This token replaces regular authorization.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Download json.png"
                src="https://dev.iridi.com/images/f/f6/Download_json.png"
              />
            </div>
          </div>
        </div>
        <p>
          <span class="label label-default"> 9</span>
          <a href="#Импорт_данных"> Import</a> the downloaded JS file to iRidi
          Studio.
        </p>
        <p>
          <span class="label label-default"> 10</span> Download your project
          with Nest driver to an object in iRidi cloud.
        </p>
        <p>
          <span style="color: red"
            ><span class="glyphicon glyphicon-info-sign"></span
          ></span>
          As it is a cloud driver, it works only if a project is started from
          the cloud.
        </p>
        <p><br /></p>
        <p><b>In case if the authorization token becomes irrelevant: </b></p>
        <p>
          <span class="label label-default"> 1</span> Follow the
          <a
            class="external text"
            href="https://cws.iridi.com/services/oauth/available"
            >link</a
          >.
        </p>
        <p>
          <span class="label label-default"> 2</span> Click
          <b>Issued tokens</b>.
        </p>
        <p>
          <span class="label label-default"> 3</span> Choose i3pro object with a
          linked Google account and Nest equipment.
        </p>
        <p>
          <span class="label label-default"> 4</span> Synchronize the token and
          click <b>Devices and structures</b>
        </p>
        <p>
          <span class="label label-default"> 5</span> Copy the access token.
        </p>
        <p>
          <span class="label label-default"> 6</span> You can update the token
          in a project via driver settings in iRidi Studio (after it the
          project must be updated in the cloud) or enter a new token in device
          settings in the sever web-interface.
        </p>
        <p><br /></p>
        <h2>
          <span class="mw-headline" id="Work_in_iRidium"></span>Work in iRidi
        </h2>
        <p>
          Create a new project and add <b>Nest Network</b> driver to it with the
          help of a scanner or entering data manually.
        </p>
        <br />
        <br />
        <h3>
          <span class="mw-headline" id="Import_of_Data"></span>Import of Data
        </h3>
        <p>
          To import commands and feedback channels of equipment from JS project,
          do the following:
        </p>
        <p>
          <span class="label label-default"> 1</span> Start iRidi studio,
          create a project and open the <b>Devices</b> panel.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Nest1.png"
                src="https://dev.iridi.com/images/5/5e/Nest1.png"
              />
            </div>
          </div>
        </div>
        <br />
        <br />
        <p>
          <span class="label label-default"> 2</span> Choose
          <b>Universal import from JS (*.js, *.json)</b> in the
          <b>Scanner / Import</b> tab and open a project file.
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Nest2.png"
                src="https://dev.iridi.com/images/4/4f/Nest2.png"
              />
            </div>
          </div>
        </div>

        <br />
        <br />
        <h3>
          <span class="mw-headline" id="Adding_Driver_Manually"></span>Adding
          Driver Manually
        </h3>
        <p>
          <span class="label label-default">1</span> Add the
          <b>Nest Network</b> driver to a created project in the
          <b>Devices</b> tab:
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Nest3.png"
                src="https://dev.iridi.com/images/7/71/Nest3.png"
              />
            </div>
          </div>
        </div>
        <br />
        <br />
        <p>
          <span class="label label-default">2</span> Click the left mouse button
          on the driver, add a subdevice (<b>Add subdevice</b>) and enter
          connection settings to the driver:
        </p>
        <div class="row">
          <div>
            <div class="thumbnail">
              <b-img
                fluid
                alt="Nest4.png"
                src="https://dev.iridi.com/images/c/cd/Nest4.png"
              />
            </div>
            <ul>
              <li><b>Log Level</b> - a level of logging;</li>
              <li>
                <b>Token</b> - an authorization token OAuth3.0 (filled in
                automatically during import).
              </li>
              <li><b>Driver Version</b> - a version of the driver.</li>
            </ul>
          </div>
          <div class="row">
            <div>
              <div class="thumbnail">
                <b-img
                  fluid
                  alt="Nest5.png"
                  src="https://dev.iridi.com/images/f/fa/Nest5.png"
                />
              </div>
              <ul>
                <li><b>Name</b> - the name of a subdevice;</li>
                <li><b>Driver Type</b> - a type of driver;</li>
                <li><b>Subdevice ID</b> - ID of a subdevice;</li>
                <li><b>Device Type</b> - a type of subdevice.</li>
              </ul>
            </div>
          </div>
        </div>
        <br />
        <br />
        <h3><span class="mw-headline" id="Devices"></span>Devices</h3>
        <p>
          Commands and feedback channels of Nest devices do not have specific
          settings. They are created when a device is added. Equipment is
          controlled by means of sending a "value" to a command (Send number,
          Send string, send value from object).
        </p>

        <br />
        <br />
        <h3><span class="mw-headline" id="Thermostat"></span>Thermostat</h3>
        <p><big>Command</big>:</p>
        <table class="table">
          <tr>
            <td><b>Command / feedback channel</b></td>
            <td><b>Input / expected values</b></td>
            <td><b>Description</b></td>
          </tr>
          <tr>
            <td>Mode Off</td>
            <td>Value</td>
            <td>Choice of mode - turn on</td>
          </tr>
          <tr>
            <td>Heat</td>
            <td>Value</td>
            <td>Choice of mode - heating.</td>
          </tr>
          <tr>
            <td>Cool</td>
            <td>Value</td>
            <td>Choice of mode - cooling.</td>
          </tr>
          <tr>
            <td>HeatCool</td>
            <td>Value</td>
            <td>Choice of mode - heating-cooling.</td>
          </tr>
          <tr>
            <td>Heat Temperature</td>
            <td>9~32</td>
            <td>Target heating temperature.</td>
          </tr>
          <tr>
            <td>Cool Temperature</td>
            <td>9~32</td>
            <td>Target cooling temperature</td>
          </tr>
          <tr>
            <td>HeatCool Low Temperature</td>
            <td>9~32</td>
            <td>The lowest temperature limit for the heating-cooling mode.</td>
          </tr>
          <tr>
            <td>HeatCool High Temperature</td>
            <td>9~32</td>
            <td>The highest temperature limit for the heating-cooling mode.</td>
          </tr>
          <tr>
            <td>Eco Mode On</td>
            <td>Value</td>
            <td>Turn on the eco mode.</td>
          </tr>
          <tr>
            <td>Eco Mode Off</td>
            <td>Value</td>
            <td>Turn off the eco mode.</td>
          </tr>
          <tr>
            <td>Fan Timer On</td>
            <td>Value</td>
            <td>Turn on ventilation for a period of time in minutes.</td>
          </tr>
          <tr>
            <td>Fan Timer Off</td>
            <td>Value</td>
            <td>Turn off ventilation.</td>
          </tr>
        </table>
        <br />
        <br />
        <p><br /><big>Feedback</big>:</p>
        <table class="table">
          <tr>
            <td><b>Command / feedback channel</b></td>
            <td><b>Input / expected values</b></td>
            <td><b>Description</b></td>
          </tr>
          <tr>
            <td>Mode</td>
            <td>
              Off, <br />
              Heat, <br />
              Cool, <br />
              HeatCool.
            </td>
            <td>The current mode.</td>
          </tr>
          <tr>
            <td>HVAC</td>
            <td>
              "OFF", <br />
              "HEATING", <br />
              "COOLING".
            </td>
            <td>The current state of a device.</td>
          </tr>
          <tr>
            <td>Eco Mode</td>
            <td>0-1</td>
            <td>
              The current eco mode: <br />
              1 - manual eco mode is on, 0 - the mode is off.
            </td>
          </tr>
          <tr>
            <td>Eco Heat</td>
            <td>Value</td>
            <td>Temperature value that makes heating work in the eco mode.</td>
          </tr>
          <tr>
            <td>Eco Cool</td>
            <td>Value</td>
            <td>Temperature value that makes cooling work in the eco mode.</td>
          </tr>
          <tr>
            <td>Temperature Heat</td>
            <td>9~32</td>
            <td>The current target heating temperature.</td>
          </tr>
          <tr>
            <td>Temperature Cool</td>
            <td>9~32</td>
            <td>The current target cooling temperature.</td>
          </tr>
          <tr>
            <td>Temperature HeatCool High</td>
            <td>9~32</td>
            <td>
              The current required highest temperature limit for the
              heating-cooling mode.
            </td>
          </tr>
          <tr>
            <td>Temperature HeatCool Low</td>
            <td>9~32</td>
            <td>
              The current required lowest temperature limit for the
              heating-cooling mode.
            </td>
          </tr>
          <tr>
            <td>Connectivity</td>
            <td>0-1</td>
            <td>
              Thermostat connection: <br />
              1 - on, 0 - off.
            </td>
          </tr>
          <tr>
            <td>Fan Mode</td>
            <td>"on / off"</td>
            <td>
              The current state of the ventilation: <br />
              on - it is on, off - it is off.
            </td>
          </tr>
          <tr>
            <td>Fan Timer Timeout</td>
            <td>Value</td>
            <td>Time when the ventilation period will be over.</td>
          </tr>
          <tr>
            <td>Humidity</td>
            <td>0~100</td>
            <td>The current humidity (%).</td>
          </tr>
          <tr>
            <td>Info</td>
            <td>"Thermostat"</td>
            <td>The name of the device in the Nest app.</td>
          </tr>
          <tr>
            <td>Settings</td>
            <td>"CELSIUS"</td>
            <td>
              Temperature measure unit: <br />
              CELSIUS, FAHRENHEIT.
            </td>
          </tr>
          <tr>
            <td>Ambient Temperature</td>
            <td>Value</td>
            <td>The current temperature</td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <div class="text-center" style="width: 100%">
      <br>
      <br>
        <router-link
            to="/policy/nest/privacy-policy-for-access-to-google-apis/en"
            >Privacy Policy for Accessing Google APIs</router-link
          >
      <br>
      <br>
      </div>
    </b-row>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.app_title {
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    display: inline-block;
    img {
      width: 60px;
      height: 60px;
    }

    &:nth-child(2) {
      margin-left: 10px;
    }
  }
}
.label {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
}

a.label:hover,
a.label:focus {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}

.label:empty {
  display: none;
}

.btn .label {
  position: relative;
  top: -1px;
}

.label-default {
  background-color: #999999;
}

.label-default[href]:hover,
.label-default[href]:focus {
  background-color: #808080;
}

.label-primary {
  background-color: #1c75bc;
}

.label-primary[href]:hover,
.label-primary[href]:focus {
  background-color: #0c7cd5;
}

.label-success {
  background-color: #4caf50;
}

.label-success[href]:hover,
.label-success[href]:focus {
  background-color: #3d8b40;
}

.label-info {
  background-color: #00bcd4;
}

.label-info[href]:hover,
.label-info[href]:focus {
  background-color: #008fa1;
}

.label-warning {
  background-color: #ff5722;
}

.label-warning[href]:hover,
.label-warning[href]:focus {
  background-color: #ee3900;
}

.label-danger {
  background-color: #f44336;
}

.label-danger[href]:hover,
.label-danger[href]:focus {
  background-color: #ea1c0d;
}
</style>
